"use strict";

import { isPairBlocked } from 'api/rpcAPICall';
import { ClassInfoDescriptions } from 'components/classInfoDescriptions';
import { fetchExtendedTags, isCountryDenied } from 'components/classInfoUtil';
import G_marketConfigStorage from 'components/globalMarketConfigStorage';
import { AdditionalActionBar } from 'components/hooks/itemDetailedHooks';
import { defineSimpleTerm, _I_ } from 'components/locs';
import { IconGlyphicon } from 'generics/icons';
import React from 'react';
import ReactGA from 'react-ga';

export class ViewAmountBadge extends React.Component  {
  render()  {
    if ( this.props.showLowCounts || (this.props.amount > 1) )
      return (<span className="badge pull-right">{this.props.amount}</span>);

    return null
  }
};


export class ViewAppIdIcon extends React.Component  {
  render()  {
    const appDesc = G_marketConfigStorage.resolveAppId( this.props.appId );

    if ( this.props.compact )
      return (<div className="view-app-brief" title={appDesc.desc.join("\n")}>
          <img className="view-app-icon" src={appDesc.icon} />
          <div className="view-app-name">
            <b>{appDesc.briefName}</b>
          </div>
          {this.props.children}
        </div>);

    return (<div className="view-app-full">
        <img className="view-app-banner" src={appDesc.banner} />
        <div><b>{appDesc.name}</b></div>
        {appDesc.desc.map( (d, key) =>  (<div key={`d_${key}`}>{d}</div>) )}
      </div>);

  }
};


export class ViewItemIconic extends React.Component  {

  render()  {
    let classInfo = this.props.classInfo;
    let iconStyle = {};
    if ( classInfo.background_color )
      iconStyle = {"backgroundColor":'#'+classInfo.background_color};

    let imageBorder = {};
    let overlayTextColor = {};

    if ( classInfo.name_color )  {
      imageBorder = {"borderColor":'#'+classInfo.name_color};
      overlayTextColor = {"color":'#'+classInfo.name_color};
    }

    const imageUrl = (this.props.large && classInfo.icon_url_large) || classInfo.icon_url;

    return (
        <div  className="view-item-icon"
              style={iconStyle}
              title={classInfo.name}
              onClick={this.props.onClick}
            >
          <div  className="view-item-icon-container">
            { (!!imageUrl) &&
              (<img  style={imageBorder} className="view-item-icon-image" src={imageUrl} />)}
          </div>
          <div  className="view-item-icon-overlay"
                style={overlayTextColor}
              >
            {this.props.children}
          </div>
        </div>
    );
  }
};


export class ClassInfoTagList extends React.Component  {
  render()  {
    const { classInfo } = this.props;

    const tags = fetchExtendedTags(
          classInfo
        ).filter(
          tagDesc  =>  tagDesc && tagDesc.name
        ).map(  (tagDesc, idx)  =>  {
            const tagColor = ( tagDesc.color ? {"color":'#'+tagDesc.color} : {} );
            return (<div  className="TagEntry" key={idx} >
                      <span className="TagEntryCategory" >{tagDesc.category_name||""}</span>
                      <span  className="TagEntryName"  style={tagColor} >{tagDesc.name||""}</span>
                    </div>);
        });

    return  (<div className="ClassInfoTagList">{tags}</div>);
  }
};


function RestrictionBlockedAfter({ blockedAfter })  {
  if (blockedAfter == 0)  {
    return false;
  }

  if (isPairBlocked(blockedAfter))  {
    return  (
        <div  className="restriction" >
              <IconGlyphicon type="warning-sign" />
              {" "}
              {_I_("ViewItemDetailed.restriction.blockedPair")}
        </div>)
  }

  const stamp = new Date(blockedAfter).toLocaleString();
  return  (
      <div  className="restriction" >
            <IconGlyphicon type="warning-sign" />
            {" "}
            {_I_("ViewItemDetailed.restriction.blockedAfter")}
            {" "}
            {stamp}
      </div>)
}


function FraudWarnings({ classInfo })  {
  const {  fraudwarnings  } = classInfo;
  if ( fraudwarnings && fraudwarnings.length )  {
    return (<span>
              {fraudwarnings.map(
                  (warnText, key)  =>  (<div className="fraud-warnings" key={key}>{warnText}</div>)
              )}
            </span>);
  }

  return false;
}


function RestrictionNonMarketable({ classInfo }) {
  return (
      (!classInfo.marketable) &&
      (<div className="restriction" >
        <IconGlyphicon type="warning-sign" />
        {" "}
        {_I_("ViewItemDetailed.restriction.nonMarketable")}
      </div>)
    );
}

function RestrictionCountryDeny({ classInfo }) {
  const countryDenied = isCountryDenied( classInfo );

  return (
      countryDenied &&
      (<div className="restriction" >
        <IconGlyphicon type="warning-sign" />
        {" "}
        {_I_("ViewItemDetailed.restriction.unclearStatus")}
      </div>)
    );
}

function RestrictionExpiresAt({ classInfo })  {
    const expireAt = +classInfo.expireAt;
    const expireAtStamp = (+expireAt > 0) && (new Date(1000*expireAt)).toLocaleString();

  return (
      (!!expireAtStamp) &&
      (<div   className="restriction" >
        <IconGlyphicon type="fire" />
        {" "}{_I_("ViewItemDetailed.restriction.expiresAt1")}
        {" "}{expireAtStamp}
        {" "}{_I_("ViewItemDetailed.restriction.expiresAt2")}
      </div>)
    );
}


export class ViewItemDetailed extends React.Component  {
  componentDidMount()  {
    const {  classInfo, appId  } = this.props;
    ReactGA.pageview('item/' + appId + '/' + encodeURI(classInfo.market_hash_name));
  }

  render()  {
    const {  classInfo, blockedAfter, appId  } = this.props;
    const assetNameColor = (classInfo.name_color ? {"color":'#'+classInfo.name_color} : null);

    return (
      <div className="ViewItemDetailed" >

        <div className="PropsPanel">
          <ViewItemIconic classInfo={classInfo} large >
            <ViewAmountBadge amount={this.props.amount} showLowCounts />
          </ViewItemIconic>


          <div className="DescriptionsPanel">
            <div className="asset-name" style={assetNameColor}>"{classInfo.name}"</div>
            <div className="asset-app-icon">
              <ViewAppIdIcon appId={appId} compact />
            </div>

            <ClassInfoTagList classInfo={classInfo} />
            <AdditionalActionBar  classInfo={classInfo} appId={appId} />

            {this.props.children}

            <div className="well well-sm text-warning WarningsPanel">
              <FraudWarnings classInfo={classInfo} />
              <RestrictionNonMarketable classInfo={classInfo} />
              <RestrictionBlockedAfter blockedAfter={blockedAfter} />
              <RestrictionExpiresAt classInfo={classInfo} />
              <RestrictionCountryDeny classInfo={classInfo} />
            </div>

            <ClassInfoDescriptions
                appid={appId}
                descriptions={classInfo.descriptions}
                owner_descriptions={classInfo.owner_descriptions}
                type="text"
              />
          </div>
        </div>

        <ClassInfoDescriptions
            appid={appId}
            descriptions={classInfo.descriptions}
            owner_descriptions={classInfo.owner_descriptions}
            type="dropped_item"
          />

        <ClassInfoDescriptions
            appid={appId}
            descriptions={classInfo.descriptions}
            owner_descriptions={classInfo.owner_descriptions}
            type="dropped_bundle"
          />

      </div>
    );
  }
};


defineSimpleTerm( "ViewItemDetailed.restriction.nonMarketable",  "Сan't be sold",       {
    "ru_RU": "Не может быть продан",
    "cs_CZ": "Сan't be sold",
    "fr_FR": "Ne peut pas être vendu",
    "de_DE": "Kann nicht verkauft werden",
    "it_IT": "Non può essere venduto",
    "ko_KR": "판매될 수 없음",
    "pl_PL": "Nie można sprzedać",
    "pt_PT": "Сan't be sold",
    "es_ES": "No puede ser vendido",
    "zh_CN": "不可出售",
    "zh_TW": "不可出售"
} );


defineSimpleTerm( "ViewItemDetailed.restriction.blockedAfter",  "Will lock at",       {
    "ru_RU": "Торговля остановится",
    "cs_CZ": "Will lock at",
    "fr_FR": "Sera fermé à",
    "de_DE": "Wird gesperrt",
    "it_IT": "Verrà bloccato tra",
    "ko_KR": "다음에 잠금될 것입니다",
    "pl_PL": "Zostanie zablokowane za",
    "pt_PT": "Will lock at",
    "es_ES": "Se bloqueara en",
    "zh_CN": "将在此后锁定",
    "zh_TW": "將在此後鎖定"
} );


defineSimpleTerm( "ViewItemDetailed.restriction.blockedPair",  "Trade locked",       {
    "ru_RU": "Торговля остановлена",
    "cs_CZ": "Trade locked",
    "fr_FR": "Marché fermé",
    "de_DE": "Handel gesperrt",
    "it_IT": "Scambio bloccato",
    "ko_KR": "거래 잠김",
    "pl_PL": "Wymiana zablokowana",
    "pt_PT": "Trade locked",
    "es_ES": "Negocio bloqueado",
    "zh_CN": "交易已锁定",
    "zh_TW": "交易已鎖定"
} );


defineSimpleTerm( "ViewItemDetailed.restriction.expiresAt1",  "Will disappear after",       {
    "ru_RU": "Пропадет после",
    "cs_CZ": "Will disappear after",
    "fr_FR": "Disparaîtra après",
    "de_DE": "Wird verschwinden nach",
    "it_IT": "Scomparirà dopo",
    "ko_KR": "소멸 예정까지",
    "pl_PL": "Zniknie za",
    "pt_PT": "Will disappear after",
    "es_ES": "Desaparecerá después",
    "zh_CN": "<time>将在此后消失",
    "zh_TW": "將在此後消失"
} );


defineSimpleTerm( "ViewItemDetailed.restriction.expiresAt2",  " ",       {
    "ru_RU": " ",
    "cs_CZ": " ",
    "fr_FR": " ",
    "de_DE": " ",
    "it_IT": " ",
    "ko_KR": " ",
    "pl_PL": " ",
    "pt_PT": " ",
    "es_ES": " ",
    "zh_CN": " ",
    "zh_TW": " "
} );

defineSimpleTerm( "ViewItemDetailed.restriction.unclearStatus",  "Due to the unclear legal status \
 of trophy cases in your country, all transactions with trophies and keys are blocked for your \
 account.",       {
   "ru_RU": "Из-за неясного юридического статуса трофеев в вашей стране, все транзакции с ними и \
   ключами заблокированы для вашего аккаунта.",
    "cs_CZ": "Due to the unclear legal status of trophy cases in your country, all transactions with trophies and keys are blocked for your account.",
    "fr_FR": "En raison des incertitudes du statut juridique des boites à de trophées dans votre pays, toutes les transactions avec des trophées et des clés sont bloquées pour votre compte.",
    "de_DE": "Aufgrund der unklaren rechtlichen Lage der Trophäentruhen in deinem Land sind alle Transaktionen mit Trophäen und Schlüsseln für dein Konto gesperrt.",
    "it_IT": "A causa di uno status legale non chiaro del trofeo nel tuo paese, tutte le transazioni con trofei e chiavi sono bloccati sul tuo account.",
    "ko_KR": "트로피 케이스에 대한 해당 국가의 법적 견해가 확실하지 않아, 계정 내 트로피와 키의 거래 기능을 이용하실 수 없습니다.",
    "pl_PL": "Z uwagi na niejasny status prawny skrzynek z trofeami w twoim kraju, transakcje związane ze skrzynkami i kluczami są zablokowane na twoim koncie.",
    "pt_PT": "Due to the unclear legal status of trophy cases in your country, all transactions with trophies and keys are blocked for your account.",
    "es_ES": "Debido al estado legal poco claro de las cajas de trofeos en tu país, todas las transacciones con trofeos y llaves están bloqueadas para tu cuenta.",
    "zh_CN": "由于你所在国家/地区的奖励情况的法律状态不明确，因此你帐户中所有带有奖励和钥匙的交易均被锁定。",
    "zh_TW": "將在此後消失：由於你所在國家/地區的獎勵情況的法律狀態不明確，因此你帳戶中所有帶有獎勵和鑰匙的交易均被鎖定。"
} );

